'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign, prefer-const */

var getColumn = function getColumn(isActive) {
  if (isActive) {
    return {
      isActive: true,
      jobs: []
    };
  }

  return {
    jobs: []
  };
};

var getLevel = function getLevel() {
  return {
    columns: []
  };
};

var getAnticipatoryColumnLength = function getAnticipatoryColumnLength(obj, job, level) {
  var index = obj[job.level].columns.reduce(function (num, column, key) {
    if (num !== null) {
      return num;
    }

    return column.jobs.reduce(function (found, j) {
      if (found !== null) {
        return found;
      }

      if (job.slug === j.slug) {
        return key;
      }

      return null;
    }, null);
  }, null);

  return obj[level].columns.slice(index).length;
};

var populateAnticipatoryJobs = function populateAnticipatoryJobs(obj, depth, job, jobs) {
  var seen = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var columnLen = getAnticipatoryColumnLength(obj, job, job.level);
  (job.anticipatory || []).forEach(function (slug) {
    if (!seen[slug]) {
      seen[slug] = true;
      var otherJob = jobs[slug];
      if (otherJob) {
        var otherJobDepth = otherJob.level < job.level ? 0 : depth;
        if (!obj[otherJob.level]) {
          obj[otherJob.level] = getLevel();
        }
        if (obj[otherJob.level].columns.length - columnLen < otherJobDepth) {
          obj[otherJob.level].columns.unshift(getColumn());
        }
        obj[otherJob.level].columns[0].jobs.push(otherJob);
        populateAnticipatoryJobs(obj, otherJobDepth + 1, otherJob, jobs, seen);
      } else {
        console.error('No job exists for: ' + slug);
      }
    }
  });

  return {
    obj: obj,
    seen: seen
  };
};

var populatePromotionalJobs = function populatePromotionalJobs(obj, depth, job, jobs) {
  var seen = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  (job.promotional || []).forEach(function (slug) {
    if (!seen[slug]) {
      seen[slug] = true;
      var promoJob = jobs[slug];
      if (promoJob) {
        var promoJobDepth = promoJob.level > job.level ? 0 : depth;
        if (!obj[promoJob.level]) {
          obj[promoJob.level] = getLevel();
        }
        if (!obj[promoJob.level].columns[promoJobDepth]) {
          obj[promoJob.level].columns[promoJobDepth] = getColumn();
        }
        obj[promoJob.level].columns[promoJobDepth].jobs.push(promoJob);
        populatePromotionalJobs(obj, promoJobDepth + 1, promoJob, jobs, seen);
      } else {
        console.error('No job exists for: ' + slug);
      }
    }
  });

  return {
    obj: obj,
    seen: seen
  };
};

var populateTransitionalJobs = function populateTransitionalJobs(obj, job, jobs, seen) {
  (job.transitional || []).forEach(function (slug) {
    if (!seen[slug]) {
      seen[slug] = true;
      var otherJob = jobs[slug];
      if (!otherJob) {
        console.error('No job exists for: ' + otherJob);
      } else if (otherJob.level !== job.level) {
        console.error('Job ' + otherJob.slug + '\'s level does not match ' + job.slug + '\'s level');
      } else {
        obj[job.level].columns[0].jobs.push(otherJob);
      }
    }
  });

  return {
    obj: obj,
    seen: seen
  };
};

var getJobsWithPositions = function getJobsWithPositions(levels) {
  return (0, _keys2.default)(levels).reduce(function (levelObj, levelKey) {
    var level = levels[levelKey];
    return (0, _extends4.default)({}, levelObj, level.columns.reduce(function (columnObj, column, columnKey) {
      return (0, _extends4.default)({}, columnObj, column.jobs.reduce(function (obj, job, index) {
        return (0, _extends4.default)({}, obj, (0, _defineProperty3.default)({}, job.slug, (0, _extends4.default)({}, job, {
          position: {
            level: levelKey,
            column: columnKey,
            index: index,
            slug: job.slug
          }
        })));
      }, {}));
    }, {}));
  }, {});
};

var getSeenSlug = function getSeenSlug(slug, otherSlug) {
  return [slug, otherSlug].sort().join('-');
};

var getConnection = function getConnection(jobs) {
  var seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var job = arguments[2];
  var attb = arguments[3];

  var arr = job[attb] || [];
  //console.log('incoming arr', arr);
  return arr.map(function (otherSlug) {
    //console.log('seen?', seen, otherSlug);
    if (!seen[getSeenSlug(job.slug, otherSlug)] && jobs[otherSlug]) {
      seen[getSeenSlug(job.slug, otherSlug)] = true;
      return {
        from: job.position,
        to: jobs[otherSlug].position
      };
    }

    return null;
  }).filter(function (el) {
    return el;
  });
};

var populateConnections = function populateConnections(levels) {
  var jobs = getJobsWithPositions(levels);
  var seen = {};
  var connections = (0, _keys2.default)(jobs).reduce(function (arr, slug) {
    //seen[slug] = true;
    var job = jobs[slug];
    return arr.concat(['promotional', 'anticipatory'].reduce(function (jobArr, attb) {
      var result = jobArr.concat(getConnection(jobs, seen, job, attb));
      return result;
    }, []));
  }, []);

  return {
    levels: levels,
    connections: connections
  };
};

var populateJobs = function populateJobs(obj, job, jobs) {
  var seen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _populateTransitional = populateTransitionalJobs(obj, job, jobs, seen),
      transObj = _populateTransitional.obj,
      transSeen = _populateTransitional.seen;

  var _populatePromotionalJ = populatePromotionalJobs(transObj, 1, job, jobs, transSeen),
      promoObj = _populatePromotionalJ.obj,
      promoSeen = _populatePromotionalJ.seen;

  var _populateAnticipatory = populateAnticipatoryJobs(promoObj, 1, job, jobs, promoSeen),
      finalObj = _populateAnticipatory.obj;

  return populateConnections(finalObj);
};

var getOrganizedJobs = function getOrganizedJobs() {
  var jobs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var job = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var obj = (0, _defineProperty3.default)({}, job.level, {
    columns: [{
      isActive: true,
      jobs: [job]
    }]
  });

  // Sanity check to make sure each job has a slug
  (0, _keys2.default)(jobs).forEach(function (slug) {
    if (!jobs[slug].slug) {
      throw new Error('Please provide a valid slug for a job');
    }
  });

  return populateJobs(obj, job, jobs, (0, _defineProperty3.default)({}, job.slug, true));
};

exports.default = getOrganizedJobs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/utils/getOrganizedJobs.js
// module id = 1178
// module chunks = 0